var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VuePagination", {
    attrs: {
      page: _vm.currentPage,
      pageCount: _vm.pageCount,
      perPage: _vm.perPage,
      perPageOptions: _vm.perPageOptions,
      paramName: _vm.paramName
    },
    on: {
      "page-changed": _vm.onPageChangedHandle,
      "per-page-changed": _vm.onPerPageChangedHandle
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }